export interface IFormula {
  id: string;
  formula: string;
  validFrom: string;
  validTo: string;
}

export interface IFieldNomination {
  id: number;
  emailTimeStamp: string;
  gasDay: string;
  counterpartyId: number;
  counterpartyName: string;
  sourceProductionFieldId: number;
  sourceProductionField: string;
  productionFieldId: number;
  productionField: string;
  terminal: string;
  subTerminal: string;
  subTerminalId: number;
  dealDealLegId: null | string;
  subTerminalStatus: string;
  fieldStatus: string;
  energy: number | null;
  persistedEnergy: number | null;
  endurEnergy: number | null;
  dayAheadNomination: number | null;
  cutoffTime: string;
  checked?: boolean;
  disabled?: boolean;
  currentAligne: null | number;
  currentCodeRunner: null | string;
  alignStatus: string;
  source: string;
  formula: IFormula[];
  fromEmail: string | null;
  subject: string | null;
  origin: string;
  isLatest: boolean;
  isWDVarianceBreach: boolean;
  isDAVarianceBreach: boolean;
  zkeywithUnit: {
    unit: string;
    zkey: string;
  }[];
  cloneFlag?: boolean;
  editFlag?: boolean;
  isMatched: number;
  isValidClone: boolean;
  children?: IFieldNomination[];
  subChildren?: IFieldNomination[];
}

export interface ISubTerminalGroup {
  subTerminal: string;
  subTerminalId: number;
  id: string;
  energy: number | null;
  persistedEnergy: number | null;
  endurEnergy: number | null;
  recordIds: number[];
  subChildren: IFieldNomination[];
  checked?: boolean;
  disabled?: boolean;
  subTerminalStatus?: string;
  dealDealLegId?: string | null;
  gasDay?: string;
  terminal: string;
}

export interface IUploadToEndur {
  open: boolean;
  onClose: () => void;
  refreshData: () => void;
  selectedUnit: string;
  data: IUploadToEndurItems[];
  renderEnergy: (energy: number | null) => React.ReactNode;
}

export interface IUploadToEndurItems {
  counterpartyId: number;
  counterpartyName: string;
  subTerminalId: string;
  subTerminal: string;
  terminal: string;
  subTerminalStatus?: string;
  dealDealLegId?: string | null;
  gasDay?: string;
  energy: number | null;
  unitsOfMeasure: string;
  ukNomFieldData: { id: number; energyInKWh: number }[];
  edigasFieldData: { id: number; energyInKWh: number }[];
}

export interface IGroupFieldNoms {
  counterpartyId: number;
  counterpartyName: string;
  id: string;
  children: ISubTerminalGroup[];
  checked?: boolean;
  disabled?: boolean;
}

export interface IEditFieldNomination {
  open: boolean;
  onClose: () => void;
  selectedItem: IFieldNomination | null;
  refreshData: () => void;
  selectedEnergy: string;
  isDayAhead: boolean;
}

export interface IFieldNominationData {
  data: IFieldNomination[];
  totalRecords: number;
}

export interface IEmailCount {
  withinDay: number;
  dayAhead: number;
}

export interface IGroupingFieldNomination {
  productionField: string;
  data: IFieldNomination[];
  expanded: boolean;
}

export interface IGroupingFieldNominationData {
  data: IGroupFieldNoms[];
  totalRecords: number;
  totalCounterparty: number;
}

export interface ITerminalMapping {
  id: number;
  zKey: number;
  unit?: string;
  counterparty: string | null;
  counterpartyId: number;
  swingContractId: number | null;
  swingContract: string | null;
  productionFieldId: number;
  productionField: string;
  sourceProductionFieldId: number;
  sourceProductionField: string;
  terminalId: number;
  terminal: string;
  subTerminalId: number;
  subTerminal: string;
  deal_DealLegId: string | null;
  dealUnit: string | null;
  formula: IFormula[];
  wdVarianceBreach: string | number;
  daVarianceBreach: string | number;
  timer: string | null;
  isMatched?: number;
  validFrom: string;
  validTo: string;
  crContractReference?: string;
  aligneSubTerminal?: string;
  autoUploadToleranceType?: string;
  autoUploadToleranceValue?: string;
}

export interface IUploadToAligne extends IFieldNomination {
  selectedZKey: string;
  unitOfMeasure: string;
  energyInKWh: number | null;
  updatedEnergy: number | null;
  comment: string;
  index: number;
  clonedCount: number;
  disableClone: boolean;
}

export interface IUploadToAligneContainer {
  open: boolean;
  onClose: () => void;
  refreshData: () => void;
  selectedUnit: string;
  data: IFieldNomination[];
}

export interface IUploadToAlignePayload {
  id: number;
  gasDay: string;
  unit: string;
  oldEnergy: number;
  newEnergy: number | null | undefined;
  zkey: string;
  comment: string;
}

export interface IAuditLogsContainer {
  open: boolean;
  onClose: () => void;
  selectedItem: IFieldNomination | null;
  renderEnergy: (energy: number | null) => void;
  selectedEnergy: string;
}

interface ISETAPayload {
  id: number;
  payloadType: string;
}

export interface IFieldAuditLogs {
  id: number;
  note: string;
  expanded: boolean;
  setaPayload: Record<string, unknown> | null;
  createdDateTimeinGMT: string;
  setaPayloadLoading?: boolean;
  payload?: ISETAPayload | null;
}

export enum IFieldType {
  FIELD_NORMS = 'field-norms',
  FIELD_MAPPING = 'field-mapping',
}

export interface GetFieldAuditLogsParams {
  url: string;
  hasLogs: boolean;
  fieldType: IFieldType;
  origin?: string;
}

export interface ILogsState {
  hasLoading: boolean;
  auditLogs: Array<IFieldAuditLogs>;
}

export enum ReportActionType {
  RUN_G1_REPORT = 'run-g1-report',
  G1_STATUS_REPORT = 'g1-status-report',
  DOWNLOAD_G1_REPORT = 'download-g1-report',
}

export interface IReportModalState {
  openReport: boolean;
  reportType: ReportActionType;
}

export interface IReportDateRange {
  fromDate: string;
  toDate: string;
}

export interface IReportDateRangePickerState extends IReportDateRange {
  isValid: boolean;
}

export type IG1StatusReportPayload = IReportDateRange & {
  orderBy: string;
  orderByDirection: string;
};

export interface IG1StatusReportDetails {
  id: number;
  runId: string;
  g1FileName: string;
  runBy: string;
  runStartTime: string;
  runEndTime: string;
  runStatus: string;
  createdDateUtc: string;
  softDelete: boolean;
}

export enum FieldNormAligneStatus {
  NEW = 'New',
  SUBMITTED = 'Submitted',
  SUCCESS = 'Success',
  FAILURE = 'Failure',
  ACKNOWLEDGED = 'Acknowledged',
  INQUEUE = 'InQueue',
}

export type FieldNormsStatusObject = {
  title: string;
  className: string;
};

export enum FieldNormAligneStatusIndex {
  NEW = 0,
  SUBMITTED = 1,
  SUCCESS = 2,
  FAILURE = 3,
  ACKNOWLEDGED = 4,
  INQUEUE = 6,
}

export type FilterAlignStatusReturnType = {
  id: number;
  name: FieldNormAligneStatus;
  isActive: boolean;
};

export type IsUploadToAligneEnabledParams = {
  fromDate: string;
  toDate: string;
};

export interface IFieldNominationAuditLogsContainer {
  open?: boolean;
  onClose?: () => void;
  selectedItem: ISubTerminalGroup | null;
}

export interface IDANomsAuditLogsProps {
  open?: boolean;
  onClose: () => void;
  fromDate: string;
  toDate: string;
}

export interface IDANomsAuditLogs {
  id: number;
  gasDay: string;
  notes: string;
  deal_DealLegId: string | null;
  statusId: number;
  createdBy: string;
  createdDateTime: string;
  comment: string | null;
  payload: string | null;
  expanded?: boolean;
}

export interface IFieldNominationAuditLogs {
  id: number;
  note: string;
  payload: {
    id: number;
    payloadType: string;
  } | null;
  createdDateTimeinGMT: string;
  expanded?: boolean;
  payloadData?: string | null;
  payloadLoading?: boolean;
}

export interface IUploadDANoms {
  open: boolean;
  onClose: () => void;
  handleRefreshData: () => void;
  fromDate: string;
  toDate: string;
}

export interface ICloneFieldNoms {
  open: boolean;
  onClose: () => void;
  refreshData: () => void;
}
